



































import { SenhaNova, UsuariosService } from "@/services/usuarios.service";
import Confirm from "@/shared/components/confirm.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { required } from "@/shared/validators";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import ComboRoles from "./components/ComboRoles.vue";

@Component({
  components: {
    Confirm,
    ComboRoles,
  },
})
export default class AlterarSenha extends mixins(GlobalMixin) {
  senha: SenhaNova = {
    idUsuario: -1,
    senhaNova: "",
  };

  loading = false;

  rules = {
    senha: [required()],
  };

  async mounted() {
    const idUsuario = Number(this.$route.params.id);

    if (!idUsuario || isNaN(idUsuario)) {
      return;
    }

    this.senha.idUsuario = idUsuario;
  }

  alterarSenha() {
    const form = this.$refs.form as any;
    if (form.validate()) {
      this.startLoader();
      UsuariosService.AlterarSenha(this.senha)
        .then(this.voltar)
        .finally(this.stopLoader);
    }
  }

  voltar() {
    this.$router.push({
      name: "usuarios",
    });
  }
}
